import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';

interface Image {
  childImageSharp: {
    gatsbyImageData: IGatsbyImageData;
  };
}
interface Item {
  id: string;
  image: Image;
}
interface OnboardingState {
  onboarding: Item;
  items: Item[];
}
export const useOnboarding = (): OnboardingState => {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        onboarding {
          id
          image {
            childImageSharp {
              gatsbyImageData(width: 700)
            }
          }
        }
        items {
          id
          image {
            childImageSharp {
              gatsbyImageData(width: 700)
            }
          }
        }
      }
    }
  `);
  return dataJson;
};
